import React from 'react';

import {
  SearchResult,
} from '../../../components';

import GroupedContentFull from '../GroupedContent/Full';
import ArticleTeaser from './teaser';
import ArticleTeaserLarge from './teaser_large';

const Article = ({ entity, className, viewMode, ...props }) => {
  switch (viewMode) {
    case 'search_result':
      return (<SearchResult entity={entity} {...props} />);
    case 'teaser':
      return (<ArticleTeaser entity={entity} {...props} />);
    case 'teaser_large':
      return (<ArticleTeaserLarge entity={entity} {...props} />);
    case 'full':
    default:
      return (<GroupedContentFull entity={entity} {...props} />);
  }
};

export default Article;
